/*
  CUSTOM: Swaps 4 info pills on the Gorgias chat home screen (Returns / Shipping / Customs / Size)
          for lookalike links to the matching Help Center articles at /pages/faq?hcUrl=...
          "Contact Us" becomes a plain link to /pages/contact-us (SWAP_CONTACT). Track order and
          Cancel order are untouched. Kill switch: ENABLED = false.
  AUTHOR: Claude / Robb
  DATE: 2026-10-08
  DEPENDS ON: None from Broadcast. Third-party: Gorgias chat widget markup (iframe#chat-window,
          pill buttons matched by label text) and the GorgiasChat JS API. Fail-safe: if the
          pills are not found it does nothing and hides nothing. Source: onepiece/gorgias/.
*/
(function () {
  'use strict';
  if (window.__opChatLinkTiles) return;

  var ENABLED = true;
  var VERSION = '2026-10-08';
  var HC_LOCALE = 'en-US';
  var CONTACT_FLOW = '01KWJAA8XFS8K5J53D00NY5086';
  var CONTACT_MATCH = 'contactus';
  var SWAP_CONTACT = true;
  var CONTACT_TILE = { flow: CONTACT_FLOW, emoji: '\uD83D\uDCAC', label: 'Contact Us', match: CONTACT_MATCH, path: 'pages/contact-us' };

  /* label = shown text (same as the native pill). match = label letters/digits, lowercased. */
  var TILES = [
    { flow: '01KVT0H744Y1W2FKY3H9Q7M9ND', emoji: '🔙',        label: 'Returns & refund policy',          match: 'returnsrefundpolicy',       slug: 'whats-your-return-policy-6567249' },
    { flow: '01KVT0S8S46CQG6ZPP7FGB0JF5', emoji: '✈️',        label: 'Shipping (rates & transit times)', match: 'shippingratestransittimes', slug: 'how-long-will-shipping-take-and-cost-6567266' },
    { flow: '01KVT1N7EPMDJ2FXEHECE38GE9', emoji: '🌎',        label: 'Customs & duties info',            match: 'customsdutiesinfo',         slug: 'will-i-be-charged-customs-and-duties-6567278' },
    { flow: '01KVT2PZR91RN8KKEG1SH97AWA', emoji: '🧍↕',  label: 'What size should I choose?',       match: 'whatsizeshouldichoose',     slug: 'what-size-should-i-choose-6567280' }
  ];

  var ATTR = 'data-op-chat-link';
  var HIDDEN_ATTR = 'data-op-hidden';

  function norm(s) { return String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, ''); }

  /* Live labels from the Gorgias config, so a renamed flow label still matches. */
  function liveLabels() {
    var out = {};
    try {
      var eps = window.gorgiasChatConfiguration.selfServiceConfiguration.workflows_entrypoints || [];
      for (var i = 0; i < eps.length; i++) out[eps[i].workflow_id] = norm(eps[i].label);
    } catch (e) { /* config not exposed: fall back to hardcoded labels */ }
    return out;
  }

  function articleUrl(t) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (t.path) return location.origin + root + t.path;
    return location.origin + root + 'pages/faq?hcUrl=' + encodeURIComponent('/' + HC_LOCALE + '/' + t.slug);
  }

  /* The row = the button's ancestor that is a direct child of the pill list.
     Default structure is button > span > div(row); computed from the common parent when 2+ pills exist. */
  function rowOf(btn, list) {
    var n = btn;
    if (list) { while (n && n.parentElement !== list) n = n.parentElement; return n; }
    return btn.parentElement && btn.parentElement.parentElement;
  }

  function commonParent(a, b) {
    var p = a.parentElement;
    while (p && !p.contains(b)) p = p.parentElement;
    return p;
  }

  function sync(doc) {
    if (!ENABLED || !doc || !doc.body) return;
    var labels = liveLabels();
    var infoKeys = {};
    TILES.forEach(function (t, i) {
      infoKeys[t.match] = i;
      if (labels[t.flow]) infoKeys[labels[t.flow]] = i;
    });
    var contactKey = labels[CONTACT_FLOW] || CONTACT_MATCH;

    var btns = doc.querySelectorAll('button');
    var info = [], contact = null, i;
    for (i = 0; i < btns.length; i++) {
      var k = norm(btns[i].textContent);
      if (k === contactKey || k === CONTACT_MATCH) { if (!contact) contact = btns[i]; }
      else if (infoKeys.hasOwnProperty(k)) info.push(btns[i]);
    }
    var anchorBtn = contact || info[0];
    if (!anchorBtn) return; /* anchor not found: do nothing, hide nothing */

    var list = null;
    if (contact && info.length) list = commonParent(contact, info[0]);
    else if (info.length > 1) list = commonParent(info[0], info[1]);
    var anchorRow = rowOf(anchorBtn, list);
    if (!anchorRow || !anchorRow.parentElement) return;
    list = anchorRow.parentElement;
    var swapContact = SWAP_CONTACT && !!contact;
    var tiles = swapContact ? TILES.concat([CONTACT_TILE]) : TILES;
    var hideKeys = {};
    for (var key in infoKeys) if (infoKeys.hasOwnProperty(key)) hideKeys[key] = true;
    if (swapContact) { hideKeys[contactKey] = true; hideKeys[CONTACT_MATCH] = true; }

    /* If the anchor is a native info pill (no Contact Us), insert before the first native info row. */
    var mine = list.querySelectorAll('[' + ATTR + ']');
    var ok = mine.length === tiles.length;
    if (ok) {
      var last = mine[mine.length - 1];
      var next = last.nextElementSibling;
      while (next && next !== anchorRow && next.hasAttribute(HIDDEN_ATTR)) next = next.nextElementSibling;
      if (contact && next !== anchorRow) ok = false;
    }
    if (!ok) {
      for (i = 0; i < mine.length; i++) mine[i].parentNode.removeChild(mine[i]);
      for (i = 0; i < tiles.length; i++) list.insertBefore(build(doc, tiles[i], anchorBtn, anchorRow), anchorRow);
    }

    /* Un-hide any row we hid that React has since reused for a different pill. */
    var hidden = list.querySelectorAll('[' + HIDDEN_ATTR + ']');
    for (i = 0; i < hidden.length; i++) {
      var hb = hidden[i].querySelector('button');
      if (!hb || !hideKeys.hasOwnProperty(norm(hb.textContent))) {
        hidden[i].style.display = '';
        hidden[i].removeAttribute(HIDDEN_ATTR);
      }
    }

    /* Hide the native info pills (only now that our links are in place). */
    var toHide = swapContact ? info.concat([contact]) : info;
    for (i = 0; i < toHide.length; i++) {
      var r = rowOf(toHide[i], list);
      if (r && r.parentElement === list && !r.hasAttribute(ATTR) && r.style.display !== 'none') {
        r.style.display = 'none';
        r.setAttribute(HIDDEN_ATTR, '1');
      }
    }
  }

  function build(doc, t, tplBtn, tplRow) {
    var tplSpan = tplBtn.parentElement !== tplRow ? tplBtn.parentElement : null;
    var row = doc.createElement(tplRow.tagName.toLowerCase());
    row.className = tplRow.className;
    row.setAttribute(ATTR, t.flow);
    var a = doc.createElement('a');
    a.className = tplBtn.className;
    a.setAttribute('shape', tplBtn.getAttribute('shape') || 'pill');
    a.setAttribute('href', articleUrl(t));
    a.setAttribute('target', '_top');
    a.style.textDecoration = 'none';
    var em = doc.createElement('span');
    em.setAttribute('aria-hidden', 'true');
    em.textContent = t.emoji;
    a.appendChild(em);
    a.appendChild(doc.createTextNode(' ' + t.label));
    a.addEventListener('click', onClick);
    if (tplSpan) {
      var span = doc.createElement('span');
      span.className = tplSpan.className;
      span.appendChild(a);
      row.appendChild(span);
    } else {
      row.appendChild(a);
    }
    return row;
  }

  /* Same tab. Close the chat first so it does not reopen over the article (Gorgias remembers open state). */
  function onClick(e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var href = this.getAttribute('href');
    e.preventDefault();
    try { if (window.GorgiasChat && window.GorgiasChat.close) window.GorgiasChat.close(); } catch (err) { /* ignore */ }
    window.location.href = href;
  }

  /* Wiring: watch for the lazily created #chat-window iframe, then watch its document. */
  var watchedDoc = null, docObserver = null, scheduled = false;

  function schedule(doc) {
    if (scheduled) return;
    scheduled = true;
    setTimeout(function () { scheduled = false; try { sync(doc); } catch (e) { /* never break the page */ } }, 0);
  }

  function attach() {
    var f = document.getElementById('chat-window');
    var doc = null;
    try { doc = f && f.contentDocument; } catch (e) { return; } /* cross-origin: give up silently */
    if (!doc || !doc.body || doc === watchedDoc) return;
    if (docObserver) docObserver.disconnect();
    watchedDoc = doc;
    docObserver = new MutationObserver(function () { schedule(doc); });
    docObserver.observe(doc.body, { childList: true, subtree: true });
    if (!f.__opLoadHooked) { f.__opLoadHooked = true; f.addEventListener('load', attach); }
    schedule(doc);
  }

  function start() {
    window.__opChatLinkTiles = { version: VERSION, sync: function () { if (watchedDoc) sync(watchedDoc); } };
    attach();
    var pageObserver = new MutationObserver(attach);
    var c = document.getElementById('gorgias-chat-container');
    pageObserver.observe(c || document.body, { childList: true, subtree: true });
    if (!c) {
      /* Container not there yet: once it appears, narrow the observer to it. */
      var narrow = new MutationObserver(function () {
        var cc = document.getElementById('gorgias-chat-container');
        if (!cc) return;
        narrow.disconnect();
        pageObserver.disconnect();
        pageObserver.observe(cc, { childList: true, subtree: true });
        attach();
      });
      narrow.observe(document.body, { childList: true });
    }
    try {
      if (window.GorgiasChat && window.GorgiasChat.on) window.GorgiasChat.on('widget:opened', attach);
      else window.addEventListener('gorgias-widget-loaded', function () {
        try { window.GorgiasChat.on('widget:opened', attach); } catch (e) { /* ignore */ }
        attach();
      });
    } catch (e) { /* ignore */ }
  }

  if (document.body) start();
  else document.addEventListener('DOMContentLoaded', start);
})();
